import {Component, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {CurrencyPipe} from "@angular/common";
import {IonItem, IonListHeader, IonRange} from "@ionic/angular/standalone";
import {PropertyService} from '../../property.service';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {FilterService} from '../../../common/filter/filter.service';
import {CurrencyConvertService} from '../../../core/currency.convert.service';
import {components} from '../../../configs/config';
import {LanguageService} from '../../../core/language.service';

@Component({
    selector: 'app-filter-popover',
    templateUrl: './filter-popover.component.html',
    styleUrls: ['./filter-popover.component.scss'],
  imports: [
    CurrencyPipe,
    IonItem,
    IonListHeader,
    IonRange,
    ReactiveFormsModule
  ]
})
export class FilterPopoverComponent  implements OnInit {

  @Input() type: string = 'price';
  @Output() filterChanged = new EventEmitter<any>();
  propertyService: PropertyService = inject(PropertyService);
  priceRange = new FormControl({ lower: 0, upper: 50000 })
  floorRange = new FormControl({ lower: 0, upper: 10 })
  ageRange = new FormControl({ lower: 0, upper: 10 });
  bedrooms = new FormControl(0);
  filterService: FilterService = inject(FilterService);
  currencyConvertService: CurrencyConvertService = inject(CurrencyConvertService);
  constructor() { }

  async ngOnInit() {
    if (Object.keys(this.filterService.filterData()).length) {
      this.updateFields(this.filterService.filterData());
    } else {

      this.updateFields(this.propertyService.filterValues());
    }
    this.priceRange.valueChanges.subscribe(async (value) => {
      if (value) {
        await this.filterByPriceRange();
      }
    });
    this.ageRange.valueChanges.subscribe(async (value) => {
      if (value) {
        await this.filterByAgeRange();
      }
    });
    this.floorRange.valueChanges.subscribe(async (value) => {
      if (value) {
        await this.filterByFloorArea();
      }
    });
    this.bedrooms.valueChanges.subscribe(async (value) => {
      if (value) {
        await this.filterByBedrooms();
      }
    });
  }
  priceRangeMin = 0;
  priceRangeMax = 0;
  async updateFields(filterValues: any) {
    console.log(filterValues);
    console.log('F ===', filterValues);
    const filterValuesInitial = this.propertyService.filterValuesInitial();
    if (!Object.keys(filterValues).length) {
      filterValues = this.propertyService.filterValues();
    } else {
      if (filterValues.beds) {
        this.bedrooms.patchValue(filterValues.beds);
      }
    }

    if (filterValues.maxPrice) {
      if (!this.currencyConvertService.exchangeRates) {
        await this.currencyConvertService.getExchangeRate();
      }
    }
    console.clear();
    try {
      this.priceRangeMin = filterValuesInitial.minPrice * this.currencyConvertService.exchangeRates[this.currencyConvertService.localCurrency()]
      this.priceRangeMax = filterValuesInitial.maxPrice * this.currencyConvertService.exchangeRates[this.currencyConvertService.localCurrency()]
    } catch (e) {}
    console.log(filterValues, this.priceRangeMin, this.priceRangeMax);
    console.log(filterValuesInitial);

    this.priceRange.patchValue({
      lower: Number(filterValues.minPrice ?? filterValuesInitial.minPrice),
      upper: Number(filterValues.maxPrice ?? filterValuesInitial.maxPrice),
    });
    console.log(this.priceRange.value);
    this.floorRange.patchValue({
      lower: filterValues.minFloorArea ?? filterValuesInitial.minFloorArea,
      upper: filterValues.maxFloorArea ?? filterValuesInitial.maxFloorArea,
    })
    this.ageRange.patchValue({
      lower: filterValues.minAge ?? filterValuesInitial.minAge,
      upper: filterValues.maxAge ?? filterValuesInitial.maxAge,
    });
  }

  async filterByPriceRange() {
    const  values: any = {};
    values.minPrice = this.priceRange.value?.lower;
    values.maxPrice = this.priceRange.value?.upper;
    await this.setData(values);
  }
  async filterByFloorArea() {
    const  values: any = {};
    values.minFloorArea = this.floorRange.value?.lower;
    values.maxFloorArea = this.floorRange.value?.upper;
    await this.setData(values);
  }
  async filterByAgeRange() {
    const  values: any = {};
    values.minAge = this.ageRange.value?.lower;
    values.maxAge = this.ageRange.value?.upper;
    await this.setData(values);
  }
  async filterByBedrooms() {
    const values: any = {};
    values.beds = this.bedrooms.value;
    if (values.beds === 0) {
      return;
    }
    await this.setData(values);
  }

  private async setData(values: any) {
    this.filterService.filterData.update(value => ({...value, ...values}));
  }
}
